<app-feedbacks-card (onAdded)="addList($event)" *ngIf="show_page == 1"></app-feedbacks-card>

<section class="Receipt gray_baack subb-admin" *ngIf="show_page == 1">
</section>